import React from 'react'
import { useTheme } from 'styled-components'
import { useLocation } from 'react-router'

import { Tab } from '../../../design-system/Tab'
import { useBotId } from '../../../../store/flow'
import { AppTheme } from '../../../../defaultTheme'
import { useLoadedBotApiUrl } from '../../../../store/app'
import { TooltipWrapper } from '../../../Step/TooltipWrapper'
import { DisableableLink } from '../../../Styleguide/DisableableLink'

export const ConversationsListTab: React.FC = () => {
  const botId = useBotId()
  const theme = useTheme()
  const location = useLocation()
  const apiUrl = useLoadedBotApiUrl()

  const conversationsListHref = `/bots/${botId}/conversations`
  const isConversationsListInHref = location.pathname.endsWith(conversationsListHref)

  const isDisabled = !apiUrl
  const disabledTabStyles = isDisabled && {
    cursor: 'not-allowed',
    padding: '0px 0px 0px 15px',
    color: (theme as AppTheme).colors.grey
  }

  return (
    <TooltipWrapper
      placement="right"
      overlayStyle={{ maxWidth: 250 }}
      overlay={isDisabled ? <span>You need to launch bot first!</span> : undefined}
    >
      <DisableableLink key="conversations-tab" disabled={isDisabled} to={conversationsListHref}>
        <Tab
          size={18}
          label="Conversations"
          style={{ ...disabledTabStyles }}
          active={isConversationsListInHref}
        />
      </DisableableLink>
    </TooltipWrapper>
  )
}
